module.exports = __webpack_public_path__ + "img/logo.2caa2e93.svg";